import { c as _c } from "react/compiler-runtime";
import { QueryClient, QueryClientProvider, isServer, keepPreviousData } from '@tanstack/react-query';
let browserQueryClient: QueryClient | undefined;
const STALE_TIME = 2 * 60 * 1000; // 2 minutes
const GC_TIME = 10 * 60 * 1000; // 10 minutes

function makeQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: STALE_TIME,
        gcTime: GC_TIME,
        placeholderData: keepPreviousData,
        refetchOnWindowFocus: 'always'
      }
    }
  });
}
export function getQueryClient() {
  if (isServer) {
    return makeQueryClient();
  } else {
    if (!browserQueryClient) browserQueryClient = makeQueryClient();
    return browserQueryClient;
  }
}
export const TanstackQueryClientProvider = t0 => {
  const $ = _c(3);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = getQueryClient();
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const query_client = t1;
  let t2;
  if ($[1] !== children) {
    t2 = <QueryClientProvider client={query_client}>{children}</QueryClientProvider>;
    $[1] = children;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};